module.exports = __webpack_public_path__ + "img/prefeituras-e-governos.f5816371.png";